export const routes = {
  auth: '/auth',

  home: '/',
  topupReturn: (requestId: number | string) => `/office/topup/${requestId}`,
  topupReturnPlaceholder: '/office/topup/:id',
  transactions: '/transactions',
  retail: '/retail',
  gasStation: '/gas-station',
  gasStationFueling: '/gas-station/fueling',
  gasStationFuelingById: (stationId: number | string) => `/gas-station/fueling/${stationId}`,
  gasStationFuelingByIdPlaceholder: '/gas-station/fueling/:stationId',
  gasStationFuelingWildcardPlaceholder: '/gas-station/fueling/*',
  gasStationFuelingComplete: '/gas-station/fueling-complete',
  travel: '/travel',

  help: '/help',
  helpTicketCreate: '/help/create',
  helpTicketConversation: (ticketId: number) => `/help/${ticketId}`,
  helpTicketConversationPlaceholder: '/help/:ticketId',

  cabinet: '/cabinet',
  profile: '/profile',
  structure: '/structure',
}
